<template>
  <div id="department-selector-box">
    <h2>Change Active Department</h2>
    <div class="departments-box">
      <div
        v-for="department in departments"
        :key="department.code"
        class="department-box flex flex-row h-14"
        @click="updateDepartmentSelected(department.code)"
      >
        <img
          v-if="selectedDepartment && selectedDepartment == department.code"
          class="selected mr-4"
          src="@/assets/icons/check.svg"
        />
        {{ department.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    departments() {
      return this.$store.getters["general/getDepartments"];
    },
    selectedDepartment() {
      return this.$store.getters["general/getActiveDepartment"]?.code;
    }
  },
  methods: {
    async updateDepartmentSelected(departmentCode) {
      let params = { ...this.$route.params };
      if (departmentCode != params.departmentCode) {
        params.departmentCode = departmentCode;

        // Update Vuex store with the new department
        const departments = this.$store.getters["general/getDepartments"];
        const newDepartment = departments.find(d => d.code === departmentCode);
        if (newDepartment) {
          await this.$store.dispatch("general/setDepartment", newDepartment);
        }

        // If current route has a name, use it, otherwise navigate to dashboard
        const routeName = this.$route.name || "DashboardPage";

        this.$router.push({ name: routeName, params }).catch(err => {
          // Ignore NavigationDuplicated errors
          if (err.name !== "NavigationDuplicated") {
            console.error("Navigation error:", err);
          }
        });
      }
      this.$emit("selected");
    }
  }
};
</script>
<style lang="scss">
#department-selector-box {
  color: black;
  text-align: center;
  .departments-box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .department-box {
      border: 1px solid #808080;
      border-radius: 7px;
      padding: 20px;
      margin: 20px;
      text-align: center;
      -webkit-box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      -moz-box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      &:hover {
        background-color: #126e6a;
        color: white;
      }
      img.selected {
        width: 20px;
      }
    }
  }
}
</style>
